class ResolveAuthenticationModes {
	constructor(public readonly email: string) {
		Object.freeze(this);
	}

	toJSON(): Record<string, unknown> {
		return {
			email: this.email,
		};
	}
}

export default ResolveAuthenticationModes;
